import {
  Fragment,
  useEffect,
  useLayoutEffect,
  useState,
  useSyncExternalStore,
  type ReactNode,
} from "react";
import { useQueryClient } from "@tanstack/react-query";
import { oturum } from "./oturum-durumu";
import { okumaOnbellegiTemizle } from "./pwa-onbellek";

export function OturumSiniri({ children }: { children: ReactNode }) {
  const sorgular = useQueryClient();
  const nesil = useSyncExternalStore(oturum.dinle, oturum.goruntu);
  const [hazir, setHazir] = useState(nesil);
  useEffect(() => oturum.sekmeleriDinle(), []);
  useLayoutEffect(() => {
    if (nesil === hazir) return;
    let gecerli = true;
    // F-AUTH-07 — yeni hesap ilk çizimde eski sorguları veya açık formları devralamaz.
    void Promise.all([sorgular.cancelQueries(), okumaOnbellegiTemizle()]).then(() => {
      if (!gecerli) return;
      sorgular.clear();
      setHazir(nesil);
    });
    return () => {
      gecerli = false;
    };
  }, [nesil, hazir, sorgular]);
  if (hazir !== nesil) return <p role="status">Oturumunuz yenileniyor…</p>;
  return <Fragment key={nesil}>{children}</Fragment>;
}
